import { render, staticRenderFns } from "./ChipSelectCombo.vue?vue&type=template&id=e0a4c63a&scoped=true&lang=pug"
import script from "./ChipSelectCombo.vue?vue&type=script&lang=ts"
export * from "./ChipSelectCombo.vue?vue&type=script&lang=ts"
import style0 from "./ChipSelectCombo.vue?vue&type=style&index=0&id=e0a4c63a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a4c63a",
  null
  
)

export default component.exports